import React, { useEffect, useMemo, useState } from 'react';
import SuggestionsWrapper from './Wrapper';
import { useSelector } from 'react-redux';
import { useSearchParams } from '../../../../components/Hooks/search-params';
import {
  makeImpactReportData,
  makeSummaryData,
} from '../../../CreativeAnalytics/CreativeCopilot/utils';
import { useCopilotApi } from '../../../CreativeAnalytics/api';
import { useSimpleImpactApi } from '../../../CreativeAnalytics/Recommendations/SimpleImpact';
import { ReportCardProvider } from '../../../CreativeAnalytics/ReportCard/contexts';
import { CreativeAnalyticsProvider } from '../../../CreativeAnalytics/contexts';
import { getSuggestions } from '../../../CreativeAnalytics/ReportCard/utils';

export const SuggestionsContainer = ({
  visual,
  start_date = new Date(),
  end_date = new Date(),
  activePage,
  category_names = [],
}) => {
  const { setParams } = useSearchParams();
  const { isROAS, isDirectMail, view_id, viewName, primary_metric } =
    useSelector(
      ({
        ViewSettings: {
          viewId,
          viewName,
          default_primary_metric,
          isROAS,
          isDirectMail,
        },
      }) => ({
        viewName,
        view_id: viewId,
        primary_metric: default_primary_metric,
        isROAS,
        isDirectMail,
      })
    );

  const copilotApi = useCopilotApi();

  const {
    data: copilotData,
    error: copilotError,
    loading: copilotLoading,
    request: copilotRequest,
  } = copilotApi.post;
  const {
    data: getSettingsData,
    error: getSettingsError,
    loading: getSettingsLoading,
    request: getSettingsRequest,
  } = copilotApi.get;

  const [clientPreferences, setClientPreferences] = useState('');
  const [advertiserDetails, setAdvertiserDetails] = useState('');
  const [previousOutput, setPreviousOutput] = useState('');
  const [userFeedback, setUserFeedback] = useState('');
  const [fixedLabels, setFixedLabels] = useState([]);
  const copilotRequestSuccess =
    copilotData && copilotData.recommendation_summary;
  const copilotRequestError =
    copilotError || (copilotData && !copilotData.recommendation_summary);

  useEffect(() => {
    if (copilotRequestSuccess) {
      setPreviousOutput(copilotData.recommendation_summary);
    }
  }, [copilotRequestSuccess]);

  const fetchCopilot = (updatedPreferences, updatedDetails) => {
    let payload = {
      PRIMARY_METRIC: primary_metric,
      ADVERTISER_DETAILS: updatedDetails || 'None',
      CLIENT_PREFERENCES: updatedPreferences || 'None',
      DNA_TABLE: [],
      IMPACT_REPORT: simpleImpactData.length
        ? makeImpactReportData(simpleImpactData)
        : {},
      // SUMMARY_DATA: makeSummaryData(navCategories.navCategories || [], isROAS),
      SUMMARY_DATA: makeSummaryData([], isROAS),
      INDEX_DATA: false,
      IS_REVISION: previousOutput ? true : false,
      USER_INSTRUCTIONS:
        'Suggest three simple ways to improve the visual based on the data. It is CRITICAL that you bullet point each suggestion.',
      PREVIOUS_OUTPUT: previousOutput || 'None',
      USER_FEEDBACK: userFeedback || 'None',
      REQUEST_TYPE: 'creative request',
      visual_example_included: visual.s3_url ? true : false,
      visual_example_labels: visual.labels
        ?.filter(
          ({ name }) =>
            !['All Visuals, All New Visuals, Top 10 Spending Visuals'].includes(
              name
            )
        )
        .map((label) => `${label.category}: ${label.name}`),
      visual_example_id: visual?.array_of_ad_ids?.[0] || 'None',
    };

    if (visual.visual_type.toLowerCase() === 'image') {
      payload = {
        ...payload,
        visual_example_url: visual.s3_url,
      };
    }

    copilotRequest(payload);
  };

  useEffect(() => {
    fetchCopilot();
  }, []);

  const simpleImpactApi = useSimpleImpactApi();

  const {
    request: simpleImpactRequest,
    data: simpleImpactData,
    loading: simpleImpactLoading,
    error: simpleImpactError,
  } = simpleImpactApi;

  // useEffect(() => {
  //   setActiveCategories(category_names);
  // }, [view_id, ]);

  const fetchImpactReportData = (data_list) => {
    simpleImpactRequest({
      data_list,
      primary_metric,
      categorical_columns: category_names,
    });
  };

  useEffect(() => {
    if (category_names.length) {
      fetchImpactReportData([]);
    }
  }, [category_names]);

  // const suggestions = useMemo(() => {
  //   if (recDepth === 1 && visual) {
  //     return getSuggestions(
  //       visual,
  //       isROAS,
  //       categorySettings,
  //       data_type,
  //       fromCreativeStudio,
  //       false,
  //       primary_metric
  //     );
  //   } else if (recData && recDepth > 1) {
  //     return recData.mock_ad_list || [];
  //   }
  // }, [
  //   visual,
  //   recDepth,
  //   recData,
  //   recsLoading,
  //   categorySettings,
  //   data_type,
  //   fromCreativeStudio,
  // ]);

  return (
    <CreativeAnalyticsProvider resultsThreshold={0}>
      <ReportCardProvider
        recDepth={null}
        setRecDepth={null}
        showMenu={null}
        setShowMenu={null}
        fixedLabels={fixedLabels}
        setFixedLabels={setFixedLabels}
        isAdvanced={null}
        setIsAdvanced={null}
        attemptedDepth={null}
        setAttemptedDepth={null}
        recsErrorDisplay={null}
        setRecsErrorDisplay={null}
        current={visual}
        isCompetitorView={false}
        isOrganicView={false}
        clientPreferences={clientPreferences}
        advertiserDetails={advertiserDetails}
        copilotApi={copilotApi}
      >
        <SuggestionsWrapper
          bestPerforming={false}
          suggestions={[]}
          recsLoading={false}
          recsError={null}
          predictions={[]}
          isROAS={isROAS}
          fromCreativeStudio={false}
          isDirectMail={isDirectMail}
          viewName={viewName}
          categories={[]}
          dispatchRevisionModal={() => {}}
          handleQuickRevisionRequest={() => {}}
          trackPath={(x) => console.log(x)}
          setParams={setParams}
          depthOptions={[]}
          fetchRecs={() => {}}
          categoryLabels={[null]}
          isDemoClient={false}
          view_id={view_id}
          start_date={start_date}
          end_date={end_date}
          darwin_direct_enabled={false}
          spendThreshold={500}
          visual_hash={visual?.array_of_ad_ids?.[0]}
          activePage={null}
          copilotData={copilotData}
          copilotLoading={copilotLoading}
          copilotRequestError={copilotRequestError}
          columns={[]}
          handleColumns={() => {}}
          fetchCopilot={fetchCopilot}
          userFeedback={userFeedback}
          setUserFeedback={setUserFeedback}
          previousOutput={previousOutput}
          tableData={[]}
        />
      </ReportCardProvider>
    </CreativeAnalyticsProvider>
  );
};
